import {openPanel} from '../sidePanel-action'

import './slideTop.styl'

export function slideFromTop(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-slideTop' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelSlideFromTop = slideFromTop
